<template>
  <Chip
    :size="ChipSize.SM"
    :variant="ChipVariant.FILLED"
    :color="chipColorByScormProgressStatus[props.status]"
    class="w-fit self-end"
  >
    {{
      t(i18nKeyByScormProgressStatus[props.status], {
        score: props.latestScore,
      })
    }}
  </Chip>
</template>
<script setup lang="ts">
import { Chip, ChipColor, ChipSize, ChipVariant } from '~/components/chip';
import { ScormProgressStatus } from '~/api/contents';

type Props = {
  status: ScormProgressStatus;
  latestScore: number | null;
};

const props = defineProps<Props>();

const { t } = useI18n();

const chipColorByScormProgressStatus: Record<ScormProgressStatus, ChipColor> = {
  [ScormProgressStatus.NOT_STARTED]: ChipColor.SECONDARY,
  [ScormProgressStatus.IN_PROGRESS]: ChipColor.TERTIARY,
  [ScormProgressStatus.PASSED]: ChipColor.SUCCESS,
  [ScormProgressStatus.FAILED]: ChipColor.ERROR,
};

const i18nKeyByScormProgressStatus: Record<ScormProgressStatus, string> = {
  [ScormProgressStatus.NOT_STARTED]: 'content.scorm-status.new',
  [ScormProgressStatus.IN_PROGRESS]: 'content.scorm-status.in-progress',
  [ScormProgressStatus.PASSED]: 'content.scorm-status.pass',
  [ScormProgressStatus.FAILED]: 'content.scorm-status.did-not-pass',
};
</script>
